import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6ffd5e91"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全部", -1))
const _hoisted_2 = { class: "ebooks" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_the_ebooks = _resolveComponent("the-ebooks")!
  const _component_the_ebooks_card = _resolveComponent("the-ebooks-card")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_back_top = _resolveComponent("a-back-top")!

  return (_openBlock(), _createBlock(_component_a_layout, {
    class: "center-container",
    style: {"background-color":"#fff"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_sider, {
        width: "200px",
        style: { overflow: 'auto', height: '90vh', position: 'fixed', background: '#ffffff', left: 0, top: '65px', bottom: 0 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "inline",
            selectedKeys: _ctx.currentKeys,
            "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentKeys) = $event)),
            defaultSelectedKeys: _ctx.currentKeys,
            "onUpdate:defaultSelectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentKeys) = $event)),
            openKeys: _ctx.openKeys,
            "onUpdate:openKeys": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.openKeys) = $event)),
            style: { height: '100%', borderRight: 0, background: '#ffffff' },
            onClick: _ctx.handleClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, { key: "ebooks" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.level1, (item) => {
                return (_openBlock(), _createBlock(_component_a_sub_menu, {
                  key: item.id,
                  disabled: false
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                      return (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: child.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(child.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selectedKeys", "defaultSelectedKeys", "openKeys", "onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout, { style: {"padding-left":"200px","background-color":"#fff"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_content, {
            class: "center-div",
            style: { background: '#fff', padding: '95px 24px 24px 24px', margin: 0, minHeight: '720px' }
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_2, [
                _createVNode(_component_the_ebooks, {
                  id: _ctx.queryCategoryId1,
                  ref: "child"
                }, null, 8, ["id"])
              ], 512), [
                [_vShow, _ctx.isShowEbooks]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_the_ebooks_card, { data: _ctx.ebooks }, null, 8, ["data"])
              ], 512), [
                [_vShow, !_ctx.isShowEbooks]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_TheFooter)
        ]),
        _: 1
      }),
      _createVNode(_component_a_back_top, { type: "default" })
    ]),
    _: 1
  }))
}